export default __webpack_public_path__ + "static/media/aboutCat2S.cb5fba35.webp";